import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthorize } from 'app/hooks/use-authorize';
import { useTrackNewListingSource } from 'app/network/listing';
import { useNewListingPrompt } from 'app/screens/new/prompt';
import { NewListingPrompt as NewListingPromptSmall } from 'app/screens/new/prompt.small';

import { ListingType } from 'app/types/listing';
import type { PublishPromptType } from 'app/atoms/ui';
import { useUISize } from 'app/utils/web-helpers';
import { CreateListingBannerButton } from './create-listing-banner-button';

export const CreateOfferBanner = function CreateOfferBanner() {
  const { t } = useTranslation('all-listings');
  const withAuthorize = useAuthorize();
  const { isSmallUI, isLargeUI } = useUISize();

  const trackNewListingSource = useTrackNewListingSource();
  const { showNewListingPrompt } = useNewListingPrompt();

  // Only used on large UI: NavigationBar already mounts a NewListingPrompt on small UI.

  const localPromptState = useState<boolean | PublishPromptType>(false);
  const [, setLocalPromptVisible] = localPromptState;

  const createOffer = () =>
    withAuthorize(() => {
      if (isSmallUI) {
        // Drives the NewListingPrompt already mounted in NavigationBar.
        showNewListingPrompt('offers_list_top_banner', ListingType.offer);
      } else {
        // On large UI, NewListingPrompt is only mounted inside PublishButton when
        // isButtonPressed is true. Use a local bottom sheet instance instead.
        trackNewListingSource('offers_list_top_banner');
        setLocalPromptVisible(ListingType.offer);
      }
    });

  return (
    <>
      <CreateListingBannerButton label={t('createYourOffer')} onPress={createOffer} />
      {isLargeUI ? <NewListingPromptSmall state={localPromptState} /> : null}
    </>
  );
};
